module.exports = __webpack_public_path__ + "img/3.d41d1e04.svg";